import {
  EXPERIENCE_HEADING_LABELS,
  NO_RIBBON_EXPERIENCE_TYPES,
  NO_RIBBON_TYPES,
} from './constants';

export function isNoRibbonStripeExperience(ribbonType, experienceType) {
  return (
    NO_RIBBON_TYPES.has(ribbonType) &&
    NO_RIBBON_EXPERIENCE_TYPES.has(experienceType)
  );
}

export function getHeading(experiences) {
  const [a, b, c] = experiences;
  const phrases = [
    EXPERIENCE_HEADING_LABELS[a?.type],
    EXPERIENCE_HEADING_LABELS[b?.type],
    EXPERIENCE_HEADING_LABELS[c?.type],
  ].filter(Boolean);

  if (phrases.length === 3) {
    return `${phrases[0]}, ${phrases[1]}, and ${phrases[2]}`;
  }

  return phrases.join(' and ');
}
